import { memo, useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import { Action } from '../../models';
import { http } from '../../lib/api/http';
import { V3 } from '../../lib/api/urls';
import { PeopleSlider } from '../person/people-slider';
import { Link } from '../styled/Link';
import { Image } from '../picture/picture';
import { PeopleModal } from '../person/people-modal';
import ArrowDown from '../../public/img/triangle-down.svg';
import { PersonInListV3 } from '../../models/person';
import userNoPhotoImg from '../../public/img/user-no-photo.png';
import { useModal } from '../../providers/modal';

function PersonsBlockMemo({ eventData }: { eventData: Action }) {
  const theme = useTheme();
  const modalState = useModal();
  const [persons, setPersons] = useState<null | { results: PersonInListV3[] }>(
    null
  );

  useEffect(() => {
    http
      .get(V3.persons, {
        limit: 50,
        offset: 0,
        event__in: eventData.id,
      })
      .then((res) => setPersons(res))
      .catch(() => setPersons(null));
  }, [eventData]);
  if (!eventData) {
    return null;
  }

  return persons && persons.results?.length ? (
    <div css={{ marginBottom: 30 }}>
      <div
        css={{
          fontFamily: 'Montserrat',
          fontSize: 13,
          fontWeight: 500,
          lineHeight: '16px',
          letterSpacing: '0.04em',
          color: theme.colors.red,
          textTransform: 'uppercase',
          marginBottom: 10,
        }}
      >
        Персоны
      </div>
      {persons.results.length > 3 ? (
        <PeopleSlider personList={persons.results} />
      ) : (
        <div css={{ display: 'flex', flexWrap: 'wrap', gap: 30 }}>
          {persons.results.map((person: any) => (
            <Link
              key={`PersonLink__${person.id}`}
              href={['', 'person', person.slug, ''].join('/')}
            >
              <div
                css={{
                  position: 'relative',
                  width: 142,
                  height: 142,
                  borderRadius: 150,
                  overflow: 'hidden',
                  objectFit: 'cover',
                }}
              >
                <Image
                  css={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                  alt={`${person.first_name} ${person.last_name}`}
                  is360
                  image={
                    person.first_image?.image
                      ? person.first_image
                      : userNoPhotoImg.src
                  }
                />
              </div>
              <div css={{ color: theme.colors.red, textAlign: 'center' }}>
                {person.first_name} {person.last_name}
              </div>
            </Link>
          ))}
        </div>
      )}
      <div
        css={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: 20,
        }}
      >
        <button
          css={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            color: '#f44336',
          }}
          type='button'
          onClick={() => {
            if (modalState) {
              modalState.setModalState((oldState) => ({
                ...oldState,
                show: true,
                content: (
                  <PeopleModal
                    personList={persons.results}
                    setModalState={modalState.setModalState}
                  />
                ),
              }));
            }
          }}
        >
          Вся творческая группа
          <ArrowDown css={{ width: 12, height: 12, fill: '#000' }} />
        </button>
      </div>
    </div>
  ) : null;
}

export const PersonsBlock = memo(
  PersonsBlockMemo,
  (oldProps, newProps) => oldProps.eventData.id === newProps.eventData.id
);
